module.exports = __webpack_public_path__ + "media/images/sm_icon02-6cbc6ad06cb92d5a61e423742ed46850.png";